const convertBackgroundsToCSS = (backgrounds) => ({
    '--backgrounds-base': backgrounds.base,
    '--backgrounds-tint-1': backgrounds.tint1,
    '--backgrounds-tint-2': backgrounds.tint2,
    '--backgrounds-tint-3': backgrounds.tint3,
    '--backgrounds-tint-4': backgrounds.tint4,
    '--backgrounds-tint-5': backgrounds.tint5,
    '--backgrounds-tint-6': backgrounds.tint6,
    '--backgrounds-transparent': backgrounds.transparent,
    '--backgrounds-panel': backgrounds.panel,
    '--backgrounds-gradient-up': backgrounds.gradientUp,
    '--backgrounds-gradient-down': backgrounds.gradientDown,
    '--backgrounds-gradient-left': backgrounds.gradientLeft,
    '--backgrounds-gradient-right': backgrounds.gradientRight,
    '--backgrounds-positive': backgrounds.positive,
    '--backgrounds-negative': backgrounds.negative,
    '--backgrounds-canvas-back-layer': backgrounds.canvasBackLayer,
});
const convertBackgroundsToObject = (backgrounds) => ({
    backgroundsBase: backgrounds.base,
    backgroundsTint1: backgrounds.tint1,
    backgroundsTint2: backgrounds.tint2,
    backgroundsTint3: backgrounds.tint3,
    backgroundsTint4: backgrounds.tint4,
    backgroundsTint5: backgrounds.tint5,
    backgroundsTint6: backgrounds.tint6,
    backgroundsTransparent: backgrounds.transparent,
    backgroundsPanel: backgrounds.panel,
    backgroundsGradientUp: backgrounds.gradientUp,
    backgroundsGradientDown: backgrounds.gradientDown,
    backgroundsGradientLeft: backgrounds.gradientLeft,
    backgroundsGradientRight: backgrounds.gradientRight,
    backgroundsPositive: backgrounds.positive,
    backgroundsNegative: backgrounds.negative,
    backgroundsCanvasBackLayer: backgrounds.canvasBackLayer,
});
const Backgrounds = {
    positive: 'var(--backgrounds-positive)',
    negative: 'var(--backgrounds-negative)',
    base: 'var(--backgrounds-base)',
    tint1: 'var(--backgrounds-tint-1)',
    tint2: 'var(--backgrounds-tint-2)',
    tint3: 'var(--backgrounds-tint-3)',
    tint4: 'var(--backgrounds-tint-4)',
    tint5: 'var(--backgrounds-tint-5)',
    tint6: 'var(--backgrounds-tint-6)',
    transparent: 'var(--backgrounds-transparent)',
    panel: 'var(--backgrounds-panel)',
    gradientUp: 'var(--backgrounds-gradient-up)',
    gradientDown: 'var(--backgrounds-gradient-down)',
    gradientLeft: 'var(--backgrounds-gradient-left)',
    gradientRight: 'var(--backgrounds-gradient-right)',
    canvasBackLayer: 'var(--backgrounds-canvas-back-layer)',
};

export { Backgrounds, convertBackgroundsToCSS, convertBackgroundsToObject };
